import React, { useState } from "react";
import { fieldError } from "../../utils/validationUtils";
import "./GiftCardForm.css";
import SuccessPopup from "../components/SuccessPopup";
import { Field } from "../components/FormControls";
import { giftCardJson } from "../../api/api";

const initial = {
    fullName: '',
    email: '',
    phone: '',
    city: '',
    street: '',
    itemsDescription: '',
    note: '',
};

export default function GiftCardForm() {
    const [form, setForm] = useState(initial);
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setForm(f => ({ ...f, [name]: value }));
        setErrors((er: any) => ({ ...er, [name]: fieldError(name, value) }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        const focusErrors: any = {
            fullName: fieldError('fullName', form.fullName),
            email: fieldError('email', form.email),
            phone: fieldError('phone', form.phone),
            city: fieldError('city', form.city),
            street: fieldError('street', form.street),
            itemsDescription: fieldError('itemsDescription', form.itemsDescription),
        };
        setErrors(focusErrors);
        if (Object.values(focusErrors).some(Boolean)) {
            setLoading(false);
            return;
        }

        try {
            await giftCardJson(form);
            setShowSuccess(true);
            setForm({ ...initial });
            setErrors({});
        } catch (error) {
            console.error("Failed to submit gift card form", error);
            alert("שגיאה בשליחת הטופס. אנא נסה שוב מאוחר יותר.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main dir="rtl" className="page">
            <SuccessPopup open={showSuccess} onClose={() => setShowSuccess(false)} />
            <div className="container">
                <div className="card">
                    <div className="title-wrap">
                        <h1 className="title">טופס תשלום גיפט קארד</h1>
                        <p className="subtitle">נא למלא פרטים בטופס מטה, ונציג יחזור אליך להמשך התהליך.</p>
                    </div>
                    <form className="form" onSubmit={handleSubmit} onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.target instanceof HTMLElement && e.target.tagName !== 'BUTTON' && e.target.tagName !== 'TEXTAREA') {
                            e.preventDefault();
                        }
                    }}>
                        <Field id="fullName" name="fullName" label="שם מלא" value={form.fullName} onChange={handleChange} error={errors.fullName} />
                        <Field id="phone" name="phone" inputMode="tel" label="טלפון" value={form.phone} onChange={handleChange} error={errors.phone} />
                        <Field id="email" name="email" label="אימייל" value={form.email} onChange={handleChange} error={errors.email} />
                        <Field id="city" name="city" label="עיר" value={form.city} onChange={handleChange} error={errors.city} />
                        <Field id="street" name="street" label="רחוב ומספר בית" value={form.street} onChange={handleChange} error={errors.street} />
                        <Field id="note" name="note" label="הערות נוספות" value={form.note} onChange={handleChange} required={false} />

                        <div className="field">
                            <div className="textarea-float-wrap">
                                <Field
                                    id="itemsDescription"
                                    name="itemsDescription"
                                    label="תיאור הפריט"
                                    value={form.itemsDescription}
                                    onChange={handleChange}
                                    error={errors.itemsDescription}
                                    textarea
                                    rows={4}
                                />
                            </div>
                        </div>
                        <div className="submit">
                            <button type="submit" className="btn" disabled={loading}>{loading ? "שולח..." : "שליחה"}</button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    );
}
